import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { changes, fields } from 'src/components/utils/fields'
import { useMediaQuery } from '@mui/material'
import { BufferService, LoadingContext, M_Button, M_Fieldset, M_Header, M_MessageBoard, M_ElementDrawer, NavigateContext } from 'src/M_Components'
import { Anchor, Refresh } from '@mui/icons-material'


export const EquipmentTypeCrud = () => {
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const [data, setData] = useState({})
    const [open, setOpen] = useState(false)
    const [passedRow, setPassedRow] = useState({})
    const [operation, setOperation] = useState('')
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [leavingPage, setLeavingPage] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [editingId, setEditingId] = useState(null) 

    const [showEquipmentClass, setShowEquipmentClass] = useState(false)
    const [newEquipmentClassData, setNewEquipmentClassData] = useState({})

    const equipmentTypeService = new BufferService('EquipmentType', 'secondary')
    const equipmentClassService = new BufferService('EquipmentClass', 'secondary')

    const sessionKeys = ['operation', 'data', 'open', 'passedRow', 'leavingPage']

    const matches = useMediaQuery('(min-width:1800px)')
    const matches2 = useMediaQuery('(min-width:1700px)')
    const matches3 = useMediaQuery('(min-width:1490px)')
    const matches4 = useMediaQuery('(min-width:1450px)')
    const matches5 = useMediaQuery('(min-width:1420px)')
    const matches6 = useMediaQuery('(min-width:1380px)')
    const matches7 = useMediaQuery('(min-width:1280px)')
    const matches8 = useMediaQuery('(min-width:1230px)')
    const matches9 = useMediaQuery('(min-width:1190px)')
    const matches10 = useMediaQuery('(min-width:1150px)')
    const matches11 = useMediaQuery('(min-width:970px)')
    const matches12 = useMediaQuery('(min-width:930px)')
    const matches13 = useMediaQuery('(min-width:850px)')
    const matches14 = useMediaQuery('(min-width:870px)')
    const matches15 = useMediaQuery('(min-width:615px)')
    const matches16 = useMediaQuery('(min-width:440px)')

    // ============================================================================
    // ==================== EQUIPMENT Class CREATION ===============================
    const addEquipmentClassFields = [
        { display: t('Class Code'), required: true, code: 'classCode', type: 'text'},
        { display: t('Class Name'), required: true, code: 'className', type: 'text'},
        { display: t('Class Type'), required: true, code: 'classType', type: 'select', options: 'classTypeBounds', extraField: 'classTypeValue' },

        { display: t('Equipment')+' '+t('Class')+' '+t('Comments'), code: 'eqClassComments', type: 'textArea', fullWidth: true, },
    ]

    const classTypeBounds = [
        { label: t('Normal'), value: 'Normal' },
        { label: t('Special'), value: 'Special' },
        { label: t('Other'), value: 'Other' },
    ]

    const saveNewEquipmentClass = () => {
        // Validations
        if (!newEquipmentClassData.classCode || !newEquipmentClassData.className || !newEquipmentClassData.classType) {
            ctx.toastMessages('error', '', t('Missing required fields'))
            return
        }
        ctx.setIsLoad(true)
        
        const equipmentClassData = {
            Code: newEquipmentClassData.classCode,
            Name: newEquipmentClassData.className,
            Type: newEquipmentClassData.classType || newEquipmentClassData.classTypeValue,
            Comments: newEquipmentClassData.eqClassComments || '',
        }

        equipmentClassService.post(equipmentClassData).then(response => {
            ctx.setIsLoad(false)
            
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', '', t('Failed to create')+' '+t('Equipment')+' '+t('Class'))
                return
            }
            
            setData(prev => ({
                ...prev,
                classCode: response.Code,
                className: response.Name,
                classCodeId: response.Id,
            }))
            
            ctx.toastMessages('success', '', t('Equipment')+' '+t('Class')+' '+t('savedSuccessfully'))
            setShowEquipmentClass(false)
            setNewEquipmentClassData({})
            
        }).catch(error => {
            ctx.setIsLoad(false)
            console.error('Error creating Equipment Class:', error)
            ctx.toastMessages('error', '', t('Failed to create')+' '+t('Equipment')+' '+t('Class'))
        })
    }
    // ============================================================================



    const EquipmentTypeFields = [
        { display: t('Eq. Type Code'), required: true, type: 'text', code: 'equipmentTypeId' },
        { display: t('EquipmentType')+' '+t('Name'), required: true, type: 'text', code: 'equipmentTypeName'},

        { display: t('Length'), required: true, type: 'decimal', code: 'length' },
        { display: t('Height'), type: 'decimal', code: 'height' },
        { display: t('Tare'), type: 'decimal', code: 'tare' },

        { display: t('EquipmentType')+' '+t('Comments'), code: 'eqTypeComments', type: 'textArea', fullWidth: true, },
    ]

    const EquipmentClassFields = [
        { display: t('Class Code'), required: true, code: 'classCode', fullWidth: true, type: 'foreignKey', entity: 'EquipmentClass', api:'secondary' , filterField: 'Code', labelFields: ['Code'], fields: [{ key: 'Name', value: 'className' }, { key: 'Code', value: 'classCode' }, { key: 'Id', value: 'classCodeId' }], },
        { display: t('Class Name'), code: 'className', type: 'disabled'},
    ]



    useEffect(() => {
        if (isFirstTime) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstTime(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))

            const editingEquipmentType = JSON.parse(sessionStorage.getItem('editingEquipmentType'))
            const operationType = sessionStorage.getItem('operationType')
            
            if (editingEquipmentType && (operationType === 'Edit' || operationType === 'Copy')) {
                editOrCopyEquipmentType(editingEquipmentType.Id, operationType === 'Copy')
                
                sessionStorage.removeItem('editingEquipmentType')
                sessionStorage.removeItem('operationType')
            } else if (operationType === 'Create') {
                setOperation('Create')
                sessionStorage.removeItem('operationType')
            }
        }
    }, [])

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [id, operation, data, leavingPage])

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0) return
        if (eval(value) instanceof String && eval(value) === '') return
        if (eval(value) instanceof Number && eval(value) === '') return

        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`))
        const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`))
        const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`))
        const tempLP = JSON.parse(sessionStorage.getItem(`${sessionID}leavingPage`))

        if ((tempO && tempO !== '') || (tempD && Object.keys(tempD).length !== 0) || tempOS || (tempPR && Object.keys(tempD).length !== 0)) {

            setOperation(new String(tempO))
            setData(new Object(tempD))
            setOpen(tempOS)
            setPassedRow(tempPR)
            setLeavingPage(tempLP || false)
            ctx.setIsLoad(false)

            return
        }
        get()
    }

    const get = () => {
        ctx.setIsLoad(false)
    }

    const refreshEquipmentType = () => {
        ctx.setIsLoad(true)
        
        sessionKeys.forEach(key => {
            sessionStorage.removeItem(`${id}${key}`)
        })
        
        // Initial values
        setData({})
        setPassedRow({})
        setOpen(false)
        setOperation('')
        setLeavingPage(false)
        setIsEditMode(false)
        setEditingId(null) 
        
        get()
        
        ctx.setIsLoad(false)
        ctx.toastMessages('success', t('Form refreshed'), '')    
    }

    const checkEquipmentTypeExists = async (code) => {
        if (!code) return false
        
        try {
            const response = await equipmentTypeService.filter(`?filter=Code eq '${code}'`)
            
            if (response.name === 'AxiosError' || !response.Items) {
                return false
            }
            
            const exactMatch = response.Items.find(item => item.Code === code)
            
            return !!exactMatch

        } catch (error) {
            console.error('Error checking equipment type:', error)
            return false
        }
    }

    const onSave = async () => {

        // Validations
        if (!data.equipmentTypeId || !data.equipmentTypeName ||  !data.classCodeId) {
            ctx.toastMessages('error', '', t('Missing required fields'))
            return
        }

        if (!isEditMode || (isEditMode && data.equipmentTypeId !== data._originalCode)) {
            ctx.setIsLoad(true)
            const exists = await checkEquipmentTypeExists(data.equipmentTypeId)
            ctx.setIsLoad(false)
            
            if (exists) {
                ctx.toastMessages('error', '', `${t('EquipmentType')} ${data.equipmentTypeId} ${t('already exists')}`)
                return
            }
        }
        
        const equipmentTypeData = {
            Code: data.equipmentTypeId,
            Name: data.equipmentTypeName,
            Length: parseFloat(data.length),
            Height: data.height ? parseFloat(data.height) : 0,
            TareWeight: data.tare ? parseFloat(data.tare) : 0,
            Comments: data.eqTypeComments || '',

            EquipmentClassId: data.classCodeId,
        }
        
        ctx.setIsLoad(true)

        const savePromise = isEditMode && editingId 
            ? equipmentTypeService.update(editingId, equipmentTypeData)
            : equipmentTypeService.post(equipmentTypeData)
        
        savePromise.then(response => {
            ctx.setIsLoad(false)
            
            if (response.name === 'AxiosError') {
                handleError(response)
                return
            }
            
            // Success
            const successMessage = isEditMode ? t('EquipmentType') + t('updatedSucessfully') : t('EquipmentType') + t('savedSucessfully')
            ctx.toastMessages('success', '', successMessage)
            
            ctx2.closeTab(JSON.parse(id), 'equipmentTypeList')            
        }).catch(error => {
            ctx.setIsLoad(false)
            handleError(error)
        })
    }

    const editOrCopyEquipmentType = (equipmentTypeId, isCopy = false) => {
        ctx.setIsLoad(true)
        
        equipmentTypeService.getId(equipmentTypeId).then(response => {
            ctx.setIsLoad(false)
            
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', '',  `${t('EquipmentType')} ${t('Failed to load')}`)
                return
            }
            
            // Mapper
            const equipmentTypeData = {
                equipmentTypeId: isCopy ? '' : (response.Code?.toString() || ''),
                equipmentTypeName: response.Name.toString(),

                length: response.Length.toString(),
                height: response.Height?.toString() || '',
                tare: response.TareWeight?.toString() || '',
                eqTypeComments: response.Comments || '',

                // Equipment Class
                classCodeId: response.EquipmentClassId?.toString(),
                
                _originalCode: response.Code?.toString() || '',
                _isCopy: isCopy,
                _originalId: isCopy ? equipmentTypeId : null
            }

            if (isCopy) {
                delete equipmentTypeData.Id
                delete equipmentTypeData.ExternalId
                delete equipmentTypeData.CreatedAt
                delete equipmentTypeData.UpdatedAt

                setIsEditMode(false)  
                setEditingId(null)        
                setOperation('Create')    
            } else {
                setIsEditMode(true)         
                setEditingId(equipmentTypeId) 
                setOperation('Edit')      
            }

            setData(equipmentTypeData)
                
            if (response.EquipmentClassId) {
                equipmentClassService.getId(response.EquipmentClassId).then(eqClassRes => {
                    if (eqClassRes.name !== 'AxiosError') {
                        changes('classCode', eqClassRes.Code, setData)
                        changes('className', eqClassRes.Name, setData)
                    }
                })
            }
        
        }).catch(error => {
            ctx.setIsLoad(false)
            console.error('Error loading equipment:', error)
            ctx.toastMessages('error', '',  `${t('EquipmentType')} ${t('Failed to load')}`)
        })
    }
    
    const handleError = (error) => {
        
        let errorMessage = t('Error saving')+' '+t('EquipmentType')
        if (Array.isArray(data)) {
            errorMessage = data.map(e => `${e.field}: ${e.message}`).join('\n')
        } else if (data?.errors) {
            errorMessage = Object.entries(data.errors)
                .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                .join('; ')
        } else if (data?.message) {
            errorMessage = data.field ? `${data.field}: ${data.message}` : data.message
        } else if (data?.detail) {
            errorMessage = data.detail
        } else if (data?.title) {
            errorMessage = data.title
        } else if (error.message) {
            errorMessage = error.message
        }

        ctx.toastMessages('error', '', errorMessage)
    }


    return (
        <div >
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Back")}
                            label={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                            onClick={() => { setLeavingPage(true) }}
                        />
                        <M_Button
                            tooltip={t("Refresh")}
                            icon={<Refresh />}
                            label={t("Refresh")}
                            onClick={() => refreshEquipmentType()}
                        />
                        <M_Button
                            tooltip={t("Save")}
                            icon={<i className="pi pi-save "></i>}
                            label={t("Save")}
                            onClick={() => onSave()}
                        />
                    </>
                }
            />
            <div style={{ margin: '20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: !matches10 && 'auto' || 'auto auto' }}>
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><Anchor style={{ marginRight: '10px', scale: '1.3' }} /> {t('EquipmentType')+' '+t('Details')}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches6 && 'auto auto' || 'auto auto auto', justifyContent: 'space-evenly' }}>
                                {EquipmentTypeFields.map((field, index) => {
                                    if (field.type === 'separator') {
                                        //New line
                                        return <div key={`separator-${index}`} style={{ gridColumn: '1 / -1', height: '0' }} />;
                                    }
                
                                    if (field.fullWidth) {
                                        return (
                                            <div key={index} style={{ gridColumn: '1 / -1', width: '100%', marginTop: '10px' }}>
                                                {fields(field, index, data, setData, false, null, '100%')}
                                            </div>
                                        );
                                    }
                                    return fields(field, index, data, setData, null, null)
                                })}
                            </div>
                        }
                    />
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><Anchor  style={{ marginRight: '10px', scale: '1.3' }} /> {t("EquipmentCode")}</div>}
                        headerElement={
                            <M_Button
                                bold
                                normal
                                hoverEffect
                                tooltip={t('Add')+' '+t('New')+' '+t('Equipment')+' '+t('Class')}
                                label={matches15 ? t('Add')+' '+t('New')+' '+t('Equipment')+' '+t('Class') : ""}
                                backgroundColor={'var(--color-green)'}
                                labelColor={'var(--color-white)'}
                                icon={<img src='/icons/svgsDaNet/plus-square.svg' alt={t("Add")} style={{ filter: 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7477%) hue-rotate(324deg) brightness(94%) contrast(109%)' }} className='iconCreateBooking' />}
                                onClick={() => setShowEquipmentClass(true)}
                            />
                        }
                        elements={

                            <div style={{ display: 'grid', gridTemplateColumns: 'auto', justifyContent: 'space-evenly' , gap: '20px'}}>
                                {EquipmentClassFields.map((field, index) => {
                                    return fields(field, index, data, setData, null, null)
                                })}
                            </div>
                        }
                    />
                </div>
                <div style={{ margin: '25px' }}></div>
            </div >

            {/* Equipment Class Creation Drawer */}
            <M_ElementDrawer
                open={showEquipmentClass}
                setOpen={setShowEquipmentClass}
                onClose={() => {
                    setShowEquipmentClass(false)
                    setNewEquipmentClassData({})
                }}
                element={
                    <div style={{ margin: '0px 5px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '20px 0px' }}>
                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <h2 style={{ color: ctx.secondaryColor, display: 'flex', alignItems: 'center', marginTop: '0px' }}><Anchor style={{ marginRight: '5px', fontSize: '30px' }} />
                                    {t('New')+' '+t('Equipment')+' '+t('Class')+' '+t('Details')}
                                </h2>
                            </span>
                            <div style={{ border: `1px solid ${ctx.primaryColor}`, width: '90%' }}></div>
                        </div>
                        
                        {/*Equipment Class Fields */}
                        <div style={{display: 'grid', gridTemplateColumns: 'auto auto auto', margin: '20px', gap: '20px', alignItems: 'start' }}>          
                            {addEquipmentClassFields.map((field, index) => {
                                if (field.fullWidth) {
                                    return (
                                        <div key={index} style={{ gridColumn: '1 / -1', width: '100%', marginTop: '10px' }}>
                                            {fields(field, index, newEquipmentClassData, setNewEquipmentClassData, false, null, '100%')}
                                        </div>
                                    );
                                }
                                return fields(field, index, newEquipmentClassData, setNewEquipmentClassData, null, null, null, classTypeBounds)
                            })}
                        </div>
                        <div style={{ margin: '30px 0' }}></div>
                        
                        {/* Buttons Save & Cancel */}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px', marginRight: '20px', marginLeft: '20px' }}>                            
                            <M_Button
                                hoverEffect
                                width={20}
                                label={t("Save")}
                                onClick={() => saveNewEquipmentClass()}
                                backgroundColor={'var(--color-green)'}
                                labelColor={'var(--color-white)'}
                            />
                            <M_Button
                                hoverEffect
                                width={15}
                                label={t("Cancel")}
                                onClick={() => {
                                    setShowEquipmentClass(false)
                                    setNewEquipmentClassData({})
                                }}
                                backgroundColor={'var(--color-red)'}
                                labelColor={'var(--color-white)'}
                            />

                        </div>
                    </div>
                }
            />
            <M_MessageBoard
                warning
                open={leavingPage}
                title={t("leavingPageTitle")}
                body={t("leavingPageBody")}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={() => { ctx2.closeTab(JSON.parse(id)); setLeavingPage(false) }} label={t("ButtonConfirm")} />
                    </span>
                }
            />
        </div >
    )
}
